import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { ILayoutsResponse, ILayouts, ICompositionAddResponse, IResponseMessage } from '../../models';
import { APIConstants } from '../../common';

@Injectable({
  providedIn: 'root'
})
export class LayoutsService {

  currentSelectedLayout!: ILayouts;

  constructor(private http: HttpClient) { }

  getAllLayouts(): Observable<ILayoutsResponse> {
    return this.http.get<ILayoutsResponse>(APIConstants.layouts);
    // const tempData: ILayoutsResponse = {
    //   data: [
    //     {
    //       id: 1,
    //       name: 'Layout 1',
    //       zone_count: 1,
    //       orientation: 'landscape',
    //       zones: [
    //         { id: 1, name: 'Zone 1', widthPercent: +'100.00', heightPercent: +'100.00', xPercent: +'0.00', yPercent: +'0.00', is_muted: false }
    //       ]
    //     },
    //     {
    //       id: 2,
    //       name: 'Layout 2',
    //       zone_count: 2,
    //       orientation: 'landscape',
    //       zones: [
    //         { id: 1, name: 'Zone 1', widthPercent: +'50.00', heightPercent: +'100.00', xPercent: +'0.00', yPercent: +'0.00', is_muted: false },
    //         { id: 2, name: 'Zone 2', widthPercent: +'50.00', heightPercent: +'100.00', xPercent: +'50.00', yPercent: +'0.00', is_muted: false }
    //       ]
    //     },
    //     {
    //       id: 3,
    //       name: 'Layout 3',
    //       zone_count: 3,
    //       orientation: 'landscape',
    //       zones: [
    //         { id: 1, name: 'Zone 1', widthPercent: +'80.00', heightPercent: +'70.00', xPercent: +'0.00', yPercent: +'0.00', is_muted: false },
    //         { id: 2, name: 'Zone 2', widthPercent: +'20.00', heightPercent: +'70.00', xPercent: +'80.00', yPercent: +'0.00', is_muted: false },
    //         { id: 3, name: 'Zone 3', widthPercent: +'100.00', heightPercent: +'30.00', xPercent: +'0.00', yPercent: +'70.00', is_muted: false }
    //       ]
    //     },
    //     {
    //       id: 4,
    //       name: 'Layout 4',
    //       zone_count: 4,
    //       orientation: 'landscape',
    //       zones: [
    //         { id: 1, name: 'Zone 1', widthPercent: +'50.00', heightPercent: +'50.00', xPercent: +'0.00', yPercent: +'0.00', is_muted: false },
    //         { id: 2, name: 'Zone 2', widthPercent: +'50.00', heightPercent: +'50.00', xPercent: +'50.00', yPercent: +'0.00', is_muted: false },
    //         { id: 3, name: 'Zone 3', widthPercent: +'50.00', heightPercent: +'50.00', xPercent: +'0.00', yPercent: +'50.00', is_muted: false },
    //         { id: 4, name: 'Zone 4', widthPercent: +'50.00', heightPercent: +'50.00', xPercent: +'50.00', yPercent: +'50.00', is_muted: false }
    //       ]
    //     },
    //     {
    //       id: 5,
    //       name: 'Layout 5',
    //       zone_count: 1,
    //       orientation: 'portrait',
    //       zones: [
    //         { id: 1, name: 'Zone 1', widthPercent: +'100.00', heightPercent: +'100.00', xPercent: +'0.00', yPercent: +'0.00', is_muted: false }
    //       ]
    //     },
    //     {
    //       id: 6,
    //       name: 'Layout 6',
    //       zone_count: 2,
    //       orientation: 'portrait',
    //       zones: [
    //         { id: 1, name: 'Zone 1', widthPercent: +'100.00', heightPercent: +'60.00', xPercent: +'0.00', yPercent: +'0.00', is_muted: false },
    //         { id: 2, name: 'Zone 2', widthPercent: +'100.00', heightPercent: +'40.00', xPercent: +'0.00', yPercent: +'60.00', is_muted: false }
    //       ]
    //     }
    //   ]
    // };

    // return of(tempData);
  }

  addLayout(layoutData: FormData): Observable<IResponseMessage> {
    return this.http.post<IResponseMessage>(APIConstants.layouts, layoutData);
  }

  updateLayout(layout_id: number, layoutData: FormData): Observable<IResponseMessage> {
    return this.http.put<IResponseMessage>(APIConstants.layouts + layout_id + '/', layoutData);
  }

  deleteLayoutById(layout_id: number): Observable<IResponseMessage> {
    return this.http.delete<IResponseMessage>(APIConstants.layouts + layout_id + '/');
  }

  getLayoutById(layout_id: number): Observable<ILayouts> {
    return this.http.get<ILayouts>(APIConstants.layouts + layout_id + '/');
  }
}
